<template>
    <div class="mt-4 mb-2 ml-3">
        <div class="layout row mb-2" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <v-btn class="mt-3" @click="addCredit" color="success"
            >Add Credit</v-btn
        >

        <div class="mt-5" v-if="details">
            <div class="font-weight-medium mb-3 layout row">
                Transaction Details
            </div>
            <v-divider class="pb-1"></v-divider>
            <v-layout row class="my-2">
                <div class="width-100 font-weight-medium">
                    Type
                </div>
                <div class="width-120 font-weight-medium">Used Account</div>
                <div class="width-220 font-weight-medium">Date</div>
                <div class="width-100 font-weight-medium">Rooms</div>
                <div class="width-100 font-weight-medium">Used Type</div>
                <div class="width-220 font-weight-medium">User</div>
                <div class="width-100 font-weight-medium">Charge</div>
                <div class="width-100 font-weight-medium">Used</div>
                <div class="width-100 font-weight-medium">Total</div>
                <div class="ml-3"></div>
            </v-layout>
            <v-divider class="pb-1"></v-divider>
            <div class="" v-for="(detail, index) in details">
                <v-layout row class="my-2">
                    <div class="width-100">
                        {{ detail.type }}
                    </div>
                    <router-link
                        class="width-120"
                        v-if="detail.usedAccountID"
                        :to="{
                            name: 'LapidusAccountView',
                            params: {
                                id: detail.usedAccountID,
                            },
                            query: {
                                isGirls: detail.usedType == 'Day Camp',
                            },
                        }"
                        >{{ detail.usedAccountID }}</router-link
                    >
                    <div class="width-120" v-if="!detail.usedAccountID">
                        {{ detail.usedAccountID }}
                    </div>
                    <div class="width-220">{{ detail.date | time }}</div>
                    <div class="width-100">{{ detail.quantity }}</div>
                    <div class="width-100">{{ detail.usedType }}</div>
                    <div class="width-220">{{ detail.byUser }}</div>
                    <div class="width-100">{{ detail.charge | currency }}</div>
                    <div class="width-100">{{ detail.used | currency }}</div>
                    <div class="width-70">{{ detail.total | currency }}</div>

                    <div class="width-50">
                        <v-btn
                            v-if="
                                detail.type == 'Used' && !detail.usedAccountID
                            "
                            class="my-0"
                            @click="printVoucher(detail)"
                            flat
                            icon
                            color="success"
                        >
                            <v-icon>mdi-printer</v-icon>
                        </v-btn>
                        <!-- <v-btn
                            small
                            dark
                            color="success"
                            class="my-0"
                            @click="printVoucher(detail)"
                            >Print Voucher</v-btn
                        > -->
                    </div>
                    <div class="ml-3">
                        <v-btn
                            small
                            dark
                            color="default"
                            class="my-0"
                            @click="editTransaction(detail)"
                            >Update & Delete</v-btn
                        >
                    </div>

                    <div
                        class="ml-3"
                        v-if="detail.note"
                        style="white-space: normal;"
                    >
                        <span class="font-weight-medium mr-2">Note:</span
                        >{{ detail.note }}
                    </div>
                </v-layout>
                <v-divider
                    class="pb-1"
                    v-if="index + 1 < details.length"
                ></v-divider>
            </div>
        </div>
        <v-dialog v-model="updateDialog" max-width="500" persistent>
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 mb-3"
                    >Lapidus
                    {{
                        clicked.type == "Charge" ? " Charge" : " Credit"
                    }}</v-card-title
                >
                <v-layout row justify-space-between>
                    <div class="font-weight-medium">Available:</div>
                    <div class="font-weight-medium">
                        {{ row.available | currency }}
                    </div>
                </v-layout>

                <div v-if="clicked.type == 'Used'">
                    <v-text-field
                        v-model="clicked.total"
                        type="number"
                        label="Amount"
                        ref="lapidusTotal"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        v-model="clicked.note"
                        label="Note"
                    ></v-text-field>
                </div>

                <div v-if="clicked.type == 'Charge'">
                    <v-text-field
                        v-model="clicked.bungalow"
                        label="Bungalow"
                        ref="lapidusBungalow"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        v-model="clicked.quantity"
                        type="number"
                        label="Rooms"
                        ref="lapidusQuantity"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        v-model="clicked.charge"
                        type="number"
                        label="Charge"
                        ref="lapidusCharge"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                        v-model="clicked.note"
                        label="Note"
                    ></v-text-field>
                    <v-layout row justify-space-between>
                        <div class="font-weight-medium">Total:</div>
                        <div class="font-weight-medium">
                            $
                            {{
                                (clicked.quantity || 0) * (clicked.charge || 0)
                            }}
                        </div>
                    </v-layout>
                </div>
                <v-card-actions class="mx-0 mt-2 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        class="mr-1"
                        @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="warning"
                        dark
                        @click="deleteTransaction()"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="update()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="lapidusCharge.newCreditDialog"
            max-width="400"
            persistent
        >
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 mb-3"
                    >Lapidus Credit</v-card-title
                >
                <v-layout row justify-space-between>
                    <div class="font-weight-medium">Available:</div>
                    <div class="font-weight-medium">
                        {{ row.available | currency }}
                    </div>
                </v-layout>
                <v-select
                    class="mt-2"
                    v-model="lapidusCharge.useType"
                    label="Use Type"
                    :items="useTypes"
                ></v-select>
                <!-- <v-text-field
                    v-model="lapidusCharge.note"
                    label="Note"
                    v-if="lapidusCharge.useType == 'Day Camp'"
                ></v-text-field> -->
                <!-- <div v-if="lapidusCharge.useType == 'Day Camp'">
                    <v-text-field
                        v-model="lapidusCharge.total"
                        type="number"
                        label="Amount"
                        ref="lapidusCreditTotal"
                        :rules="[rules.required]"
                    ></v-text-field>
                </div> -->
                <div v-if="hasMatchingAccounts(lapidusCharge.useType)">
                    <v-select
                        class="mt-2"
                        v-model="selectedAccount"
                        label="Account"
                        :items="
                            getAccountsMatchingBungalows(lapidusCharge.useType)
                        "
                    ></v-select>
                </div>
                <div
                    v-if="!hasMatchingAccounts(lapidusCharge.useType)"
                    class="text-danger"
                >
                    No account to apply credit
                </div>
                <v-card-actions class="mx-0 mt-2 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        class="mr-1"
                        @click="lapidusCharge.newCreditDialog = false"
                        >Cancel</v-btn
                    >
                    <!-- <v-btn
                        v-if="lapidusCharge.useType == 'Day Camp'"
                        :loading="processing"
                        color="success"
                        @click="saveNewCredit()"
                    >
                        Save
                    </v-btn> -->
                    <v-btn
                        color="success"
                        @click="
                            makePayment(lapidusCharge.useType == 'Day Camp')
                        "
                    >
                        Make Payment
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, onlyUnique } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            details: [],

            clicked: "",

            useTypes: ["Cheider", "Day Camp"],
            accountsMatchingBungalows: [],
            matchingLapidusDaycampAccounts: [],
            matchingLapidusAccounts: [],
            selectedAccount: "",

            updateDialog: false,
            processing: false,

            lapidusCharge: {
                newCreditDialog: false,
                useType: "",
                total: 0,
                id: 0,
                rowClicked: "",
                note: "",
            },

            rules: {
                required: (value) => !!value || "Required",
            },
        };
    },
    async created() {
        this.loadDetails();
    },
    computed: {},
    methods: {
        async loadDetails() {
            const regID = "LP" + this.row.year;

            const response = await this.$http.get(
                "api/lapidusTransactions/getForAccount?regID=" +
                    regID +
                    "&accountID=" +
                    this.row.accountID
            );

            this.details = response.lapidusTransactions.map((transaction) => {
                transaction.used =
                    transaction.type == "Used" ? transaction.total : 0;

                if (!transaction.usedTransactionID) return transaction;

                const usedTransaction = response.transactions.find(
                    (t) => t.txnID == transaction.usedTransactionID
                );

                transaction.usedAccountID = usedTransaction
                    ? usedTransaction.accountID
                    : "";

                return transaction;
            });
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "date",
                    "previousBalance",
                    "currentBalance"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        printVoucher(transaction) {
            const newWindow = window.open(
                "",
                "Receipt",
                "width=800, height=800"
            );

            newWindow.document.write(this.createVoucher(transaction));
        },
        createVoucher(transaction) {
            let html = `<!DOCTYPE html>
                <html style="margin: 10px; padding: 10px; border-style: solid;">
                <head>
                <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                }

                td, th {
                  padding: 6px;
                }
                .no-border td, th {
                    border: none;
                }
                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                }
                .regular-text {
                    margin-bottom: 5px;
                    margin-top: 0px;
                }
                .title {
                    font-size: 25px;
                }
                </style>
                </head>
                <body>
                <p class="regular-text" style="text-align: center;"><span style="font-size: 13pt;"><strong><span style="font-family: arial, helvetica, sans-serif;">ת"ת תורה ויראה דרבינו יואל מ'סאטמאר</span> </strong></span></p>
                            <p class="regular-text" style="text-align: center;"><span style="font-size: 11pt;"><span style="font-family: arial, helvetica, sans-serif;">שע"י סאטמאר באנגעלאו קאלאני</span></span></p>
                            <p>&nbsp;</p>

                <p style="text-align: center;" class="account-info title"><strong>${
                    transaction.usedType
                } Voucher</strong></p>

                <p style="text-align: right;" class="account-info"><strong>${moment().format(
                    "L"
                )}</strong></p>

                <div class="account-info">
                <p class="regular-text"><strong>${this.row.name}</strong></p>
                <p class="regular-text"><strong>Address: </strong>${
                    this.row.nameH
                }</p>`;

            html += `<table class="no-border" align="right" style="width: 35%;" border="1">
                    <tbody>

                    <td>Amount</td>
                    <td style="text-align: right;"><strong>$${
                        transaction.total
                    }</strong></td>
                    </tr>
                    </tbody>
                    </table>
                    </body>
                </html>`;

            return html;
        },
        editTransaction(detail) {
            this.clicked = JSON.parse(JSON.stringify(detail));
            this.updateDialog = true;
        },
        validate() {
            if (this.clicked.type == "Charge") {
                return (
                    this.$refs.lapidusBungalow.validate(true) &&
                    this.$refs.lapidusQuantity.validate(true) &&
                    this.$refs.lapidusCharge.validate(true)
                );
            }

            return this.$refs.lapidusTotal.validate(true);
        },
        async update() {
            if (!this.validate()) return;

            const total =
                this.clicked.type == "Charge"
                    ? (this.clicked.quantity || 0) * (this.clicked.charge || 0)
                    : this.clicked.total;

            if (this.clicked.type == "Charge" && this.row.used > total) {
                this.$notify({
                    text: "Can't change to lower amount than used",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const originalTotal = this.details.find(
                (d) => d.id == this.clicked.id
            ).total;
            const available = this.row.available + originalTotal;

            if (this.clicked.type == "Used" && total > available) {
                this.$notify({
                    text: "Can't change to more than $" + available,
                    group: "notification",
                    type: "error",
                });

                return;
            }

            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                const year = moment().format("YYYY");

                await this.$http.post(
                    "api/lapidusDayCamp/saveLapidusTransaction",
                    {
                        accountID: this.row.accountID,
                        type: this.clicked.type,
                        year: this.clicked.year,
                        date: today,
                        byUser: this.$store.state.authentication.user,
                        bungalow: this.clicked.bungalow,
                        quantity: this.clicked.quantity,
                        charge: this.clicked.charge,
                        id: this.clicked.id,
                        note: this.clicked.note,
                        total: total,
                    }
                );

                this.processing = false;
                this.updateDialog = false;

                this.loadDetails();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteTransaction() {
            if (
                this.clicked.type == "Charge" &&
                this.details.filter((d) => d.type == "Used").length
            ) {
                this.$notify({
                    text:
                        "Can't delete charge, please delete all credits first",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            await this.$http.post(
                "api/lapidusTransactions/delete?id=" + this.clicked.id
            );

            this.loadDetails();
            this.reloadGrid();
        },
        async saveNewCredit() {
            if (!this.$refs.lapidusCreditTotal.validate(true)) return;

            if (this.lapidusCharge.total > this.row.available) {
                this.$notify({
                    text:
                        "Only $" +
                        this.row.available +
                        " is available to use. please change the amount",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");
                const year = this.row.year;

                await this.$http.post(
                    "api/lapidusDayCamp/saveLapidusTransaction",
                    {
                        accountID: this.row.accountID,
                        type: "Used",
                        year: year,
                        date: today,
                        usedType: this.lapidusCharge.useType,
                        note: this.lapidusCharge.note,
                        byUser: this.$store.state.authentication.user,
                        total: this.lapidusCharge.total,
                    }
                );

                this.lapidusCharge.useType = "";
                this.lapidusCharge.note = "";
                this.lapidusCharge.total = "";

                this.processing = false;
                this.lapidusCharge.newCreditDialog = false;

                this.loadDetails();
                this.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async addCredit() {
            this.selectedAccount = "";
            this.lapidusCharge.newCreditDialog = true;

            const response = await this.$http.get(
                "api/lapidusDayCamp/getAccountsForBungalow?year=" +
                    this.row.year +
                    "&bungalow=" +
                    this.row.bungalow
            );

            this.matchingLapidusDaycampAccounts =
                response.matchingLapidusDaycampAccounts;
            this.matchingLapidusAccounts = response.matchingLapidusAccounts;

            const accounts = response.matchingLapidusAccounts.concat(
                response.matchingLapidusDaycampAccounts
            );

            this.accountsMatchingBungalows = accounts
                .map((a) => a.accountID)
                .filter(onlyUnique);

            if (this.accountsMatchingBungalows.length) {
                this.selectedAccount = this.accountsMatchingBungalows.some(
                    (a) => a == this.row.accountID
                )
                    ? this.row.accountID
                    : "";
            }
        },
        hasMatchingAccounts(type) {
            if (!type) return true;

            return type == "Day Camp"
                ? this.matchingLapidusDaycampAccounts.length
                : this.matchingLapidusAccounts.length;
        },
        getAccountsMatchingBungalows(type) {
            return type == "Day Camp"
                ? this.matchingLapidusDaycampAccounts.map((a) => a.accountID)
                : this.matchingLapidusAccounts.map((a) => a.accountID);
        },
        makePayment(isDayCampPayment = false) {
            let accountID = this.selectedAccount;

            if (!accountID) {
                this.$notify({
                    text: "Please select an account",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.$router.push({
                name: "LapidusAccountView",
                params: {
                    id: accountID,
                    reg_id: "LP" + this.row.year,
                },
                query: {
                    voucherPayment: true,
                    voucherAccount: this.row.accountID,
                    isGirls: isDayCampPayment,
                },
            });
        },
    },
};
</script>
<style></style>
